/**
 * Created by liubo on 15/8/31.
 */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import fetchMiddleware from './../middleware/fetch';
import analysisBMiddleware from './../middleware/analysisBefore';
import analysisAMiddleware from './../middleware/analysisAfter';
import promiseMiddleware from 'redux-promise-middleware';
//创建日志
const loggerMiddleware = createLogger({
  level: 'info',
  collapsed: true,
  predicate: (getState, action) => __DEVELOPMENT__
});
//判断是否为对象
function isObj(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
// Creates a preconfigured store for this example.
export default function ConfigureStore(reducers, middleware, initialState) {
  let reducer;
  if (isObj(reducers)) {
    reducer = combineReducers(reducers);
  } else if (typeof reducers === 'function') {
    reducer = reducers;
  } else {
    throw new Error('Make sure the type of reducers is object or function.');
  }
  const customMiddleware = [thunkMiddleware, analysisBMiddleware, promiseMiddleware({
    promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAILURE']
  }), fetchMiddleware(), analysisAMiddleware, loggerMiddleware, ...middleware];
  //添加中间件
  const createStoreWithMiddleware = applyMiddleware(...customMiddleware)(createStore);
  return createStoreWithMiddleware(reducer, initialState);
}